import { PageLink } from "components/App/utils";
import { Page } from "./index";

export const NoPagesPage = () => {
    return <Page title="No pages" link={PageLink.NoPages} isAnonymous components={[]} />;
};
